import { GetTheAppMobileButton } from "./header/get-the-app-mobile-button"
import { HeaderImage, HeaderImageMobile } from "./header/header-image"
import { GetTheAppDesktop } from "./header/get-the-app-desktop"
import { HeaderText } from "./header/header-text"
import { Logo } from "./logo"

export function Header() {
  return (
    <div className="bg-gradient-to-b from-neutral-100 max-md:mb-[-88px] max-md:via-support-lime max-md:to-white md:to-support-lime">
      <div className="flex w-full flex-col items-center px-8 pt-4 md:flex-row md:items-start md:px-8 md:pt-0 lg:px-16">
        <div className="mx-auto w-full max-w-7xl">
          <div className="flex w-full flex-col md:flex-row">
            <div className="text-center md:mb-12 md:flex md:w-1/2 md:flex-col md:justify-start md:gap-24 md:text-left">
              <div className="max-md:pb-8 md:mt-12 md:self-start">
                <Logo className="mx-auto h-[40px] md:h-[60px]" />
              </div>

              <div className="">
                <HeaderText />

                <GetTheAppDesktop />
              </div>

              <GetTheAppMobileButton />
            </div>

            <div className="">
              <div className="relative md:mb-[-64px] md:mr-[-32px] lg:mr-[-64px]">
                <HeaderImage />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="overflow-x-hidden md:hidden">
        <HeaderImageMobile />
      </div>
    </div>
  )
}
